<template>
<!--  <PageLoader v-if="loading"/>-->
  <div id="scrollable-list-container" ref="table" class="table-container scroll-y" style="overflow-x: hidden;height: 50vh!important;max-height: 100%!important;">
    <div class="h-200px d-flex justify-content-center align-items-center" v-if="loading && !projects.length">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">{{ $t("loadingText") }}</span>
        </div>
      </div>
    </div>
    <div v-else-if="!projects.length">
      <div class="h-350px d-flex justify-content-center align-items-center" >
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-125px h-sm-175px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.noData') }}</h2>
        </div>
      </div>
    </div>
    <div v-else class="row p-7">
      <div class="col-md-6 col-lg-4 col-xl-4 col-xxl-3 mb-7" v-for="project in projects" :key="project.id">
        <ProjectCard  :project="project" :handleProjectClick="projectView" @reloadData="reloadData"/>
      </div>
      <div class="h-200px d-flex justify-content-center align-items-center" v-if="loading && projects.length">
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">{{ $t("loadingText") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import {computed, ref, watch, reactive, onMounted, defineProps} from "vue";
  import { useRouter} from "vue-router";
  import {useStore} from "vuex";
  import ProjectCard from "../../components/ProjectCard.vue";
  import Img from "@/components/Img.vue";
  import PageLoader from "@/components/PageLoader.vue";

  const router = useRouter()
  const store = useStore()

  const props = defineProps({
    office: {
      type: String, required: true
    },
    filterData: {
      type: Object,
      required: true
    },
    keyNumber: {
      type: Number,
      required: true
    }
  })

  const loading = ref(false)

  const projects = computed(() => (store.getters['projects/getProjects']))
  const projectsMeta = computed(() => (store.getters['projects/getProjectsMeta']))

  watch(() => props.keyNumber, (value) => {
   if(props.office) store.dispatch("projects/loadProjects", {...props.filterData, office: props.office})
  })

  watch(() => [props.filterData, props.office], () => {
    if(props.office) projectCards({...props.filterData, office: props.office})
  }, {deep: true})

  function projectView(id) {
    router.push({name: 'projects-view', params: {id}, query:{office: props.office}})
  }

  function projectCards(filterData) {
    loading.value = true
    if(props.office)  store.dispatch("projects/loadProjects", filterData).finally(() => loading.value = false)
  }

  function reloadData () {
    projectCards({...props.filterData, office: props.office})
  }

  const loadNextPage = () => {
    const container = document.getElementById('scrollable-list-container');

    container.addEventListener('scroll', () => {
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
        if (!loading.value) {
          if(projectsMeta.value.current_page < projectsMeta.value.last_page){
            projectCards({...props.filterData, office: props.office, page: projectsMeta.value.current_page + 1});
          }
        }
      }
    });
  };

  onMounted(async() => {
    await store.dispatch('projects/loadProjectReactionEnum')
    if(props.office) projectCards({...props.filterData, office: props.office})
    loadNextPage()
  })
</script>
  
<style scoped>
  .table-container {
    height: 470px;
  }
  thead th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
  } 
  </style>